module.exports = __webpack_public_path__ + "media/img/corporate/logos/microsoft-b28c6fdeb86817f0e2fa8ad3b81ee1d2.svg";